import React, { Component } from "react";
import NavBarHeader from "../NavBarHeader/NavBarHeader";
import ScrolltoTop from "../ScrollTop/ScrollTop";
import "../ID_SRUFiles/ID_SRUFiles.css";
import TranslationFile from "../15-Translation/locale/Translation_apps.json";
import Footer_contact_tab from "../Footerpage/Footer_contact_tab";
let userSelectedLanguage;

class ID_SRUFiles extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentWillMount() {
    userSelectedLanguage = localStorage.getItem("selectedLanguage");

    window.scrollTo(0, 0);
  }

  render() {
    return (
      <div>
        <NavBarHeader />
        <div className="ID_SRU_Homepage">
          <br></br>
          <br></br>
          
          <section
            style={{
              fontSize: "25px",
              fontWeight: "800",
              textAlign: "center",
            }}
          >
            {TranslationFile.ComingSoonText[userSelectedLanguage]}
          </section>
          
        </div>
        <ScrolltoTop />
        <Footer_contact_tab sideBar={this.state.sideBarStatus} isCorpPortal={false} isHomePage={true} />

      </div>
    );
  }
}
export default ID_SRUFiles;
